import { ReactNode, useEffect, useState } from 'react';
import { Box, Link, Popover, Text } from '@nimbus-ds/components';
import useStorage from 'commons/hooks/useStorage';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import './CreateSavedSearchPopover.scss';

interface CreateSavedSearchPopoverProps {
  onSave: () => void;
  children: ReactNode;
}

export function CreateSavedSearchPopover({
  onSave,
  children,
}: Readonly<CreateSavedSearchPopoverProps>) {
  const [show, setShow, loaded] = useStorage(
    'orders-saved-searches-new-feature-popover',
    true,
  );

  const [tempShow, setTempShow] = useState(show);

  useEffect(() => setTempShow(show), [show]);

  const t = useTranslationOrders('savedSearches');

  const handleSave = () => {
    setTempShow(false);
    onSave();
  };

  const handleVisiblityChange = (visible: boolean) => {
    if (!visible) {
      setShow(false);
    }
  };

  return (
    <Popover
      position="bottom-end"
      visible={tempShow && loaded}
      width="280px"
      backgroundColor="primary-interactiveHover"
      color="neutral-background"
      onVisibility={handleVisiblityChange}
      content={
        <div className="stratus--orders-create-saved-search-popover">
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            alignItems="flex-start"
            gap="4"
          >
            <Text
              fontSize="base"
              fontWeight="medium"
              color="neutral-background"
            >
              {t('creationPopover.title')}
            </Text>
            <Link as={Link} onClick={handleSave} appearance="primary">
              {t('creationPopover.action')}
            </Link>
          </Box>
        </div>
      }
    >
      {children}
    </Popover>
  );
}
